module.exports = __webpack_public_path__ + "minus.png?5a379c46656d7a393c8f1ab293e46def";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vis/dist/img/network/minus.png
// module id = 575
// module chunks = 0